import React, { useEffect } from "react";
import { Box } from "@mui/material";
import PageContent from "./partials/PageContent";
import PageHeader from "./partials/PageHeader";
import AOS from "aos";

const PageAutomationSolution = ({ pageAutomationData }) => {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);

  const {
    title = "Automatización Robótica de Procesos (RPA)",
    description = "Descripción no disponible",
    content = "Contenido no disponible",
    image = null,
  } = pageAutomationData?.page_automation || {};

  return (
    <Box className="solution-page" id="page-automation">
      <PageHeader
        title={title}
        prev="End to End Circuitos"
        hrefPrev="/solutions/tour-circuits"
        next="Servicios de Discovery Tecnológico para la Industria de Viajes"
        hrefNext="/solutions/discovery"
      />

      <PageContent
        content={content}
        title={title}
        description={description}
        image={image}
      />
    </Box>
  );
};

export default PageAutomationSolution;
